import { render, staticRenderFns } from "./stepBox.vue?vue&type=template&id=0d1bc2f9&scoped=true"
import script from "./stepBox.vue?vue&type=script&lang=js"
export * from "./stepBox.vue?vue&type=script&lang=js"
import style0 from "./stepBox.vue?vue&type=style&index=0&id=0d1bc2f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1bc2f9",
  null
  
)

export default component.exports